import React from 'react';
import { Col, Row, Form, Select, Empty, Button, Spin } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import SelectBox from '../form/selectBox';

const { Option } = Select;

const BillingBlock = ({
  form,
  companies,
  setCompanies,
  childCompanies,
  setChildCompanies,
  costsCenters,
  setCostsCenters,
  showChildCompanies,
  childCompanyLoading,
  setChildCompanyModal,
  handleOnChangeSearch,
  addCompany,
  searchChildCompanies,
  sessionBranchOfficeId,
  countrySettings,
  countryCode,
  invoiceCompanyOptions
}) => {
  const { t } = useTranslation();

  const renderCostCenterInput = () => {
    if (costsCenters && costsCenters.length) {
      return (
        <Col lg={8} xs={24}>
          <Row>
            <Col lg={24} xs={24}>
              <Form.Item
                name="cost_center_id"
                label="Centro de costo"
                className="mb-10"
              >
                <Select
                  className="cmt-select"
                  placeholder="Ingrese el centro de costo"
                  showArrow={false}
                  showSearch
                  filterOption={true}
                  allowClear
                  onChange={(value, option) => {
                    if (value) {
                      handleOnChangeSearch('costCenter', value, option, setCostsCenters);
                    } else {
                      form.setFieldsValue({ cost_center_id: null });
                    }
                  }}
                  onClear={() => form.setFieldsValue({ cost_center_id: null })}
                  notFoundContent={
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={
                        <div className="empty-search">
                          <div>No hay Coincidencias</div>
                        </div>
                      }
                    />
                  }
                >
                  {
                    costsCenters?.map(option => (
                      <Option key={option.id} value={option.id}>
                        {option.name}
                      </Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      );
    }
    return null;
  };

  return (
    <>
      <SelectBox
        sessionBranchOfficeId={sessionBranchOfficeId}
        handleOnChangeSearch={handleOnChangeSearch}
        setter={setCompanies}
        list={companies}
        formName="company_id"
        label={t('reservations.generalDataForm.companyLabel')}
        placeholder={t('reservations.generalDataForm.companyPlaceholder')}
        buttonText={t('reservations.generalDataForm.createCompanyButton')}
        field='company'
        requireMessage='Empresa es requerida'
        editButtonId='editCompany'
        createButtonId='createNewCompany'
        shouldUpdate={(prevValues, currentValues) => prevValues.company_id !== currentValues.company_id}
        handleModalResult={addCompany}
        form={form}
        createTitle={t('reservations.companyModal.createCompanyTitle')}
        editTitle={t('reservations.companyModal.updateCompanyTitle')}
        setModal='setCompanyModal'
        fetch='fetchCompanies'
        hideActions={true}
        formClassName="mb-10"
      />

      {countrySettings.generalData.outsourcing[countryCode] && (
        <SelectBox
          sessionBranchOfficeId={sessionBranchOfficeId}
          handleOnChangeSearch={handleOnChangeSearch}
          setter={setCompanies}
          list={companies}
          formName="outsourcing_id"
          label={t('reservations.generalDataForm.outsourcingLabel')}
          placeholder={t('reservations.generalDataForm.outsourcingPlaceholder')}
          buttonText={t('reservations.generalDataForm.createOutsourcingButton')}
          field='outsourcing'
          editButtonId='editOutsourcing'
          createButtonId='createNewOutsourcing'
          shouldUpdate={(prevValues, currentValues) => prevValues.company_id !== currentValues.company_id}
          handleModalResult={addCompany}
          form={form}
          createTitle={t('reservations.companyModal.createOutsourcingTitle')}
          editTitle={t('reservations.companyModal.updateOutsourcingTitle')}
          setModal='setCompanyModal'
          fetch='fetchCompanies'
          hideActions={true}
          formClassName="mb-10"
        />
      )}

      {countrySettings.generalData.thirdCompany[countryCode] && (
        <SelectBox
          sessionBranchOfficeId={sessionBranchOfficeId}
          handleOnChangeSearch={handleOnChangeSearch}
          setter={setCompanies}
          list={companies}
          formName="third_company_id"
          label={t('reservations.generalDataForm.thirdCompanyLabel')}
          placeholder={t('reservations.generalDataForm.thirdCompanyPlaceholder')}
          buttonText={t('reservations.generalDataForm.createThirdCompanyButton')}
          field='thirdCompany'
          editButtonId='editThirdCompany'
          createButtonId='createNewThirdCompany'
          shouldUpdate={(prevValues, currentValues) => prevValues.company_id !== currentValues.company_id}
          handleModalResult={addCompany}
          form={form}
          createTitle={t('reservations.companyModal.createThirdCompanyTitle')}
          editTitle={t('reservations.companyModal.updateThirdCompanyTitle')}
          setModal='setCompanyModal'
          fetch='fetchCompanies'
          hideActions={true}
          formClassName="mb-10"
        />
      )}

      {countrySettings.generalData.invoiceTo[countryCode] && (
        <Col lg={8} xs={24}>
          <Form.Item
            name="invoice_company_id"
            label={t('reservations.generalDataForm.invoiceCompanyLabel')}
            rules={[{ required: true, message: 'Facturar a es requerido' }]}
            className="mb-10"
          >
            <Select
              className="cmt-select"
              placeholder={t('reservations.generalDataForm.invoiceCompanyPlaceholder')}
              showArrow={false}
              allowClear
              onClear={() => form.setFieldsValue({ invoice_company_id: undefined })}
              notFoundContent={
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <div className="empty-search">
                      <div>Seleccione primero una empresa, subcontrata o tercera empresa</div>
                    </div>
                  }
                />
              }
            >
              {invoiceCompanyOptions?.map(option => (
                <Option key={option.id} value={option.id}>
                  {option.business_name || option.document_number || option.id}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      )}

      {showChildCompanies && (
        <Col lg={8} xs={24}>
          <Spin className="cmt-spin" spinning={childCompanyLoading}>
            <Row>
              <Col lg={22} xs={22}>
                <Form.Item
                  name="child_company_id"
                  label={t('reservations.generalDataForm.subCompanyLabel')}
                >
                  <Select
                    className="cmt-select"
                    placeholder={t('reservations.generalDataForm.subCompanyPlaceholder')}
                    showSearch
                    showArrow={false}
                    filterOption={false}
                    allowClear
                    onSearch={searchChildCompanies}
                    onChange={(value, option) => handleOnChangeSearch('subCompany', value, option, setChildCompanies)}
                    onClear={(value, option) => handleOnChangeSearch('subCompany', value, option, setChildCompanies)}
                    notFoundContent={
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                          <div className="empty-search">
                            <div>No hay coincidencias</div>
                            <div>
                              <Button
                                type="link"
                                onClick={() => setChildCompanyModal({ type: 'create', visible: true })}
                              >
                                {t('reservations.generalDataForm.createSubCompanyButton')}
                              </Button>
                            </div>
                          </div>
                        }
                      />
                    }
                  >
                    {childCompanies && childCompanies.length > 0 &&
                      childCompanies.map(option => (
                        <Option key={option.id} value={option.id}>
                          {option.business_name}
                        </Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={2} xs={2}>
                <Form.Item
                  width={{ width: '100%' }}
                  label="&nbsp;"
                  shouldUpdate={(prevValues, currentValues) => prevValues.child_company_id !== currentValues.child_company_id}
                >
                  {({ getFieldValue }) =>
                    getFieldValue('child_company_id') ? (
                      <Button block onClick={() => setChildCompanyModal({ type: 'edit', visible: true })} icon={<EditOutlined />} />
                    ) : (
                      <Button block onClick={() => setChildCompanyModal({ type: 'create', visible: true })} icon={<PlusOutlined />} />
                    )
                  }
                </Form.Item>
              </Col>
            </Row>
          </Spin>
        </Col>
      )}

      {renderCostCenterInput()}
    </>
  );
};

export default BillingBlock;
